import CIMSTable from 'components/CIMSTable'
import { useEJLogContext } from '../../EJLogContext'
import DraftSubmitEJModal from './components/DraftSubmitEJModal'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import { useCreate } from './hooks/useCreate'
import { useCustom } from './hooks/useCustom'
import { useEdit } from './hooks/useEdit'
import EditEJModal from './components/EditEJModal'
import RevertEJModal from './components/RevertEJModal'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'
import { usePayItems } from './hooks/usePayItems'

const EJLogTable: React.VFC = () => {
  const { records, refetch, fetching } = useEJLogContext()

  return (
    <CIMSTable
      loading={fetching}
      records={records}
      rowKey={'id'}
      columns={useColumns()}
      actions={{
        header: {
          deepLinkKey: 'id',
          payItems: usePayItems(),
          onReload: refetch,
          create: useCreate(),
        },
        row: {
          edit: useEdit(),
          custom: useCustom(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
      expand={useExpand()}
    >
      <DraftSubmitEJModal />
      <EditEJModal />
      <RevertEJModal />
    </CIMSTable>
  )
}

export default EJLogTable
